interface ImageCardProps {
  image: string;
  onDelete: () => void;
}

export default function ImageCard({ image, onDelete }: ImageCardProps) {
  return (
    <div className="relative h-44 overflow-hidden rounded-2xl border border-gray-200">
      <img src={image} alt="Product" className="h-full w-full object-cover" />

      <button
        type="button"
        onClick={onDelete}
        className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-red-500 text-sm text-white hover:bg-red-600">
        ✕
      </button>
    </div>
  );
}
